import React from 'react';
import { Table, Empty } from 'antd';

export default function Referencias(props) {
    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Orden',
                        dataIndex: 'orden',
                        key: 'orden',

                        render: (data, row, index) => (
                            <span>{index + 1}</span>
                        )
                    },
                    {
                        title: 'Tipo Comprobante',
                        dataIndex: 'nombreTipoComprobante',
                        key: 'nombreTipoComprobante'
                    },
                    {
                        title: 'Serie',
                        dataIndex: 'serie',
                        key: 'serie'
                    },
                    {
                        title: 'Documento',
                        dataIndex: 'documento',
                        key: 'documento'
                    },
                    {
                        title: 'Fecha Emisión',
                        dataIndex: 'fechaEmision',
                        key: 'fechaEmision'
                    },
                    {
                        title: 'Motivo',
                        dataIndex: 'motivo',
                        key: 'motivo'
                    }
                ]}
            />
        </div>
    );
}